import { render } from "./SvgEmail.vue?vue&type=template&id=ee8dd426"
const script = {}

import exportComponent from "/var/www/digiasia.asia.bak/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__